/** API codes for login / MFA endpoints */
export enum MfaApiCode {
  Ok = 1,
  Failed = 0,
  Verified = 200,
  Unauthorized = 401,
  Forbidden = 403,
  InvalidOtp = 404
}

export interface LoginCredentials {
  email: string;
  password: string;
}

/** POST /auth/login — after password validated */
export interface LoginStartResponse {
  code: number;
  mfa_required: boolean;
  challenge: string;
  qr_code?: string;
  requires_qr_setup?: boolean;
  message?: string;
  error?: string;
}

export interface MfaChallengeResult {
  challenge: string;
  qrCodeUrl?: string;
  requiresQrSetup: boolean;
}

export interface MfaVerifyResult {
  passwordExpired: boolean;
}

export interface MfaResponse {
  qr_code?: string;
  code?: number;
  message?: string;
  password_expired?: boolean;
  challenge?: string;
  mfa_required?: boolean;
  requires_qr_setup?: boolean;
  error?: string;
}

export class LoginFlowError extends Error {
  constructor(
    readonly code:
      | 'RECAPTCHA'
      | 'MFA_CHECK_FAILED'
      | 'USER_INACTIVE'
      | 'INVALID_OTP'
      | 'AUTH_DENIED'
      | 'PASSWORD_UPDATE_FAILED'
      | 'OAUTH_FAILED',
    message?: string
  ) {
    super(message ?? code);
    this.name = 'LoginFlowError';
  }
}
